import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicBreadcrumb from "./BasicBreadcrumb";
import BasicBreadcrumbWithIcon from "./BasicBreadcrumbWithIcon";

const BreadcrumbPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Breadcrumbs"}
        description={
          "A breadcrumbs is a list of links that help visualize a page's location within a site's hierarchical structure, it allows navigation up to any of the ancestors."
        }
      />
      <Divider light />

      <BasicBreadcrumb />
      <BasicBreadcrumbWithIcon />
    </Paper>
  );
};

export default BreadcrumbPage;
